import ReportGroup from '../model/ReportGroup'
import { configuration } from './Configuration'
import { fetchWithAccessToken } from './SiteConfig-api'
export const loadReportGroupList = (): Promise<ReportGroup[]> =>
  loadReportGroupListFromURL(`${configuration.SmartAPI}report-groups/`)

const loadReportGroupListFromURL = (url: string): Promise<ReportGroup[]> => {
  return fetchWithAccessToken(url, 'SmartApi').then(function(response: Response) {
    if (response.status !== 200) {
      throw response.statusText
    }
    // Convert to JSON
    return response.json()
  })
}
